import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@workspace/ui/components/sonner';
import { updateAccountApi } from '../-api/api';

interface UpdateAccountNameInput {
  urn: string;
  name: string;
}

export function useUpdateAccountName() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ urn, name }: UpdateAccountNameInput) => {
      return updateAccountApi(urn, {
        metadata: { name },
      });
    },
    onSuccess: (data) => {
      if (data.error) {
        console.error('Error al actualizar el nombre:', data.data);
        toast.error('No se pudo actualizar el nombre. Intenta de nuevo.');
        return;
      }
      queryClient.invalidateQueries({ queryKey: ['cards'] });
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
      toast.success('Nombre actualizado correctamente');
    },
  });
}
